module.exports = __webpack_public_path__ + "img/26.problem_broken_toilet.186be481.svg";